import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Login from './pages/Authentication/Login'
import ForgotCredentials from 'pages/Authentication/ForgotCredentials'
import MFA from 'pages/Authentication/MFA'
import ClientsList from 'pages/ClientsList'
import ClientDetails from 'pages/ClientDetails'
import Mails from 'pages/Mails'
import Exports from 'pages/Exports'
import FreeAnswers from 'pages/FreeAnswers'
import Facturation from 'pages/Facturation'
import Home from 'pages/Home'
import { withTracker } from 'react-tag-commander'
import TagCommander from 'components/TagCommander'
import Healthcheck from 'components/Healthcheck'
import MissingFreeAnswerSubmits from 'components/MissingFreeAnswerSubmits'

TagCommander.getInstance()
const opts = TagCommander.withTrackerOpts()

const Routes = () =>
  <>
    <MissingFreeAnswerSubmits />
    <Router>
      <Switch>
        <Route exact path="/healthcheck" component={Healthcheck} />

        <Route exact path="/login" component={withTracker(Login, opts)} />

        <Route exact path="/forgot-credentials" component={withTracker(ForgotCredentials, opts)} />

        <Route exact path="/mfa" component={withTracker(MFA, opts)} />

        <Route exact path="/" component={withTracker(Home, opts)} />

        <Route exact path="/clients" component={withTracker(ClientsList, opts)} />

        <Route exact path="/client/:clientId" component={withTracker(ClientDetails, opts)} />

        <Route exact path="/mails" component={withTracker(Mails, opts)} />

        <Route exact path="/exports" component={withTracker(Exports, opts)} />

        <Route exact path="/libre-réponses" component={withTracker(FreeAnswers, opts)} />

        <Route exact path="/facturation" component={withTracker(Facturation, opts)} />
      </Switch>
    </Router>
  </>

export default Routes
